import { render, staticRenderFns } from "./elem-upload.vue?vue&type=template&id=761f8a3a&"
import script from "./elem-upload.vue?vue&type=script&lang=js&"
export * from "./elem-upload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports